/*global window, jQuery, calendar */
(function($) {

  'use strict';

  $(function() {

  	var Shuffle = window.Shuffle;
		var element = document.querySelector('.shuffle-container');
		
		var shuffleInstance = new Shuffle(element, {
		  itemSelector: '.spazio_box_evento',
		  sizer: null
		});
		if (window.filterActive != '') {
			shuffleInstance.filter(window.filterActive);
		} else {
			shuffleInstance.filter(Shuffle.ALL_ITEMS);
		} 

  	$('#filter').on('change', function(){
  		console.log(this.value);
  		shuffleInstance.filter(this.value);

  		//window.history.pushState(this.value, 'Title', calendar.baseURL + '/' + this.value);
  	})

  	window.onpopstate = function(e){
		    if(e.state){
		        //document.getElementById("content").innerHTML = e.state.html;
		        //document.title = e.state.pageTitle;
		    }
		};

		shuffleInstance.on(Shuffle.EventType.LAYOUT, function () {
		  console.log('Things finished moving!');
		  var tot = $('.spazio_box_evento').length + 10;
		  $('.spazio_box_evento').each(function(){
		  	console.log(tot + ' !important');
		  	$(this).attr('style', $(this).attr('style') + '; ' + 'z-index: ' + tot +' !important');//.style('z-index', tot, 'important');
		  	tot = tot -1;
		  });
		});


  });



}(jQuery));
